"use strict";

exports.__esModule = true;
exports["default"] = createGetFormInitialValues;

function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };

      return getIn(nonNullGetFormState(state), form + ".initial");
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/selectors/getFormInitialValues.js
// module id = 2204
// module chunks = 0